import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useParams } from 'react-router-dom';
import Loader from 'components/loader/Loader';
import RetryPanel from 'containers/partials/error-boundary/RetryPanel';
import usePostMessage from 'hooks/utils/usePostMessage';
import { useIntl } from 'react-intl';
import messages from 'messages';
import Reports from 'containers/pages/mobile/reports/Reports';
import useReports from 'hooks/queries/useReports';
import { useStore } from 'stores/Store';

const OverviewReports = () => {
  const intl = useIntl();
  const { entityId } = useParams();
  const { fetchReports, loading, error } = useReports({ entityId });
  const { sendMessage } = usePostMessage();
  const reports = useStore(state => state.reports);

  useEffect(() => {
    const fetchData = async () => {
      await fetchReports();
    };

    fetchData().catch(error => {
      Sentry.captureException(error);
    });
  }, []);

  useEffect(() => {
    const data = {
      title: intl.formatMessage(messages.titleReports),
      description: intl.formatMessage(messages.subtitleAthleteSessions),
      canGoBack: false
    };
    sendMessage({ message: data });
  }, []);

  if (loading || reports === null) return <Loader />;
  if (error) return <RetryPanel />;

  return <Reports entityId={entityId} />;
};

export default OverviewReports;
